export default {"src":"/_next/static/media/deviantart.038fa0a4.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};